<template>
  <div class="teacher-edit">
    <el-dialog title="修改教师信息" :visible="dialogVisible" @open="dialogOpen" @close="dialogClose"
      :close-on-click-modal="false" width="480px" center>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="姓名:" prop="teacherName">
                <el-input v-model="ruleForm.teacherName" placeholder="请输入教师姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="教师工号:" prop="teacherNumber">
                <el-input v-model="ruleForm.teacherNumber" placeholder="请输入教师工号"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="手机号:" prop="phone">
                <el-input v-model="ruleForm.phone" placeholder="请输入手机号" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="入职时间:">
                <el-form-item prop="entryDate">
                  <el-date-picker type="date" placeholder="请选择入职时间" v-model="ruleForm.entryDate"
                    value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="性别:" prop="teacherName">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="导师类型:" prop="mentorType">
            <el-select v-model="ruleForm.mentorType" multiple placeholder="请选择">
              <el-option v-for="item in mentorTypeList" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-button type="primary" round size="small" @click="resetPassword"
            >重置密码</el-button
          > -->
          <el-form-item label="个人简介:" prop="resume">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" v-model="ruleForm.resume"
              :maxlength="maxlength" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="comfrim('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    teacherInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mentorTypeList: {
      type: Array,
    }
  },
  inject: ["refresh"],
  created() { },
  data() {
    let phoneCodeVerification = /^1[3-9][0-9]{9}$/;
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneCodeVerification.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        teacherName: "",
        teacherNumber: "",
        entryDate: "",
        phone: "",
        resume: "",
        mentorType: "",
        sex: "男"
      },
      rules: {
        teacherName: [
          { required: true, message: "请输入教师姓名", trigger: "blur" },
        ],
        teacherNumber: [
          { required: true, message: "请输入教师工号", trigger: "blur" },
        ],
        mentorType: [
          { required: false, message: "请选择导师类型", trigger: "change" },
        ],
        phone: [{ validator: validatePhone, required: true, trigger: "blur" }],
      },
      maxlength: 100, // textarea字数
      formLabelWidth: "120px",
      inputVisible: false,
      inputValue: "",
    };
  },
  methods: {
    dialogOpen() {
      let { teacherName, teacherNumber, phone, entryDate, resume, mentorType, sex } =
        this.teacherInfo;
      this.ruleForm.teacherName = teacherName;
      this.ruleForm.teacherNumber = teacherNumber;
      this.ruleForm.phone = phone;
      this.ruleForm.entryDate = entryDate;
      this.ruleForm.resume = resume;
      this.ruleForm.mentorType = mentorType == '' ? mentorType : mentorType.split(",");
      this.ruleForm.sex = sex ? sex : "男";
    },
    dialogClose() {
      let { teacherName, teacherNumber, phone, entryDate, resume, sex, mentorType } =
        this.teacherInfo;
      this.ruleForm.teacherName = teacherName;
      this.ruleForm.teacherNumber = teacherNumber;
      this.ruleForm.phone = phone;
      this.ruleForm.entryDate = entryDate;
      this.ruleForm.resume = resume;
      this.ruleForm.sex = sex ? sex : "男";
      this.ruleForm.mentorType = mentorType == '' ? mentorType : mentorType.split(",");
      this.$emit("update:dialogVisible", false);
    },
    comfrim(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log("ruleForm=> ", this.ruleForm);
          // console.log("teacherInfo=> ", this.teacherInfo);
          let { teacherName, teacherNumber, entryDate, resume, phone, sex, mentorType } =
            this.ruleForm;
          let submit = {
            id: this.teacherInfo.id,
            teacherName,
            teacherNumber,
            phone,
            entryDate,
            resume,
            sex,
            mentorType: mentorType.join(',')
          };
          // 调用接口修改教师信息
          // console.log(submit);
          this.post(this.$url.updateTeacherPC, submit)
            .then((res) => {
              // console.log(res);
              
              if (res.code == 200) {
                this.$message.success("修改成功");
                // 刷新列表
                this.refresh();
                // // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error("修改失败");
              }
            })
            .catch((err) => {
              this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacher-edit.scss";
</style>
